export const BREAKPOINTS = {
  minWidth: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
    xl2: 1600
  },
  maxWidth: {
    xs: 575,
    sm: 767,
    md: 991,
    lg: 1199,
    xl: 1399,
    xxl: 1599
  }
};
